<template>
    <div class="nk-content nk-content-fluid">
        <div class="container-xl wide-lg">
            <div class="nk-content-body">
                <div class="components-preview wide-md mx-auto">
                    <div class="nk-block-head nk-block-head-lg wide-sm">
                        <div class="nk-block-head-content">
                            <h4 class="nk-block-title fw-normal">Add Expense</h4>
                        </div>
                    </div>
                    <div class="nk-block nk-block-lg">
                        <div class="card">
                            <div class="card-inner">
                                <div class="preview-block">
                                    <div class="row gy-4">
                                        <div class="col-sm-12 col-md-8 col-lg-8 col-xl-8">
                                            <div class="row gy-4">
                                                <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                                    <div class="form-group">
                                                        <label class="form-label">Cash/Bank Account:*</label>
                                                        <div class="form-control-wrap">
                                                            <accountdropdown v-model="newPaymentOption.cashBankAccountId" :prop="'Bank'" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                                    <div class="form-group">
                                                        <label class="form-label">Expense Account:*</label>
                                                        <div class="form-control-wrap">
                                                            <accountdropdown v-model="newPaymentOption.accountId" :prop="'Expense'" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                                    <div class="form-group">
                                                        <label class="form-label" for="default-01">Amount</label>
                                                        <div class="form-control-wrap">
                                                            <input v-model="newPaymentOption.amount" type="number" class="form-control" id="default-01">
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                    <div class="form-group">
                                                        <label class="form-label">Narration</label>
                                                        <div class="form-control-wrap">
                                                            <textarea v-model="newPaymentOption.description" type="text" class="form-control"></textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label">Attachment</label>
                                                <div class="form-control-wrap">
                                                    <uploadimage v-on:picPath="getImage" v-bind:path="newPaymentOption.image" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <hr class="preview-hr">
                                    <div class="row gy-4 ">
                                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 ">
                                            <button v-bind:disabled="$v.$invalid" v-on:click="SaveNewUser()" class="btn btn-primary" style="margin-right: 10px;"> Save</button>
                                            <a href="javascript:void(0)" v-on:click="GoToList()" class="btn btn-danger"> Cancel</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <loading :name="loading" :active.sync="loading"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
    </div>
</template>
<script>
    import { required } from 'vuelidate/lib/validators';
    import Loading from 'vue-loading-overlay';
    import "vue-loading-overlay/dist/vue-loading.css";

    export default ({
        components: {
            Loading
        },
        name: 'AddDailyExpense',
        data: function () {
            return {
                loading: false,
                newPaymentOption: {
                    id: '00000000-0000-0000-0000-000000000000',
                    description: '',
                    approvalStatus: 'Approved',
                    cashBankAccountId: '',
                    accountId: '',
                    paymentType: '',
                    image: '',
                    amount: 0,
                }
            }
        },
        validations: {
            newPaymentOption:
            {
                cashBankAccountId:
                {
                    required
                },
                accountId:
                {
                    required
                },
                amount:
                {
                    required
                }
            }
        },

        methods: {
            getImage: function (path) {
                this.newPaymentOption.image = path;
            },

            GoToList: function () {
                this.$router.push('/DailyExpenses')
            },

            SaveNewUser: function () {
                var root = this;
                this.loading = true;

                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.post('/Accounting/SaveDailyExpense', this.newPaymentOption, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        console.log(response.data)
                        if (response.data.id != '00000000-0000-0000-0000-000000000000' && response.data.isSuccess) {
                            root.loading = false;
                            root.$swal({
                                title: 'Added!',
                                text: 'Data has been Saved successfully.',
                                type: 'success',
                                icon: 'success',
                                confirmButtonClass: "btn btn-success",
                                buttonsStyling: false
                            }).then(function (result) {
                                if (result) {
                                    root.GoToList();
                                }
                            });
                        }
                        else {
                            root.$swal({
                                title: 'Error!',
                                text: response.data.isAddUpdate,
                                type: 'error',
                                icon: 'error',
                                confirmButtonClass: "btn btn-danger",
                                buttonsStyling: false
                            });
                            root.loading = false;
                        }
                    }).catch(error => {
                        console.log(error)
                        root.$swal.fire(
                            {
                                icon: 'error',
                                type: 'error',
                                title: 'Error',
                                text: "Something Went Wrong",
                                showConfirmButton: false,
                                timer: 5000,
                                timerProgressBar: true,
                            });

                        root.loading = false;
                    })
                    .finally(() => root.loading = false);
            },

        },
        created: function () {

            if (this.$route.query.data != undefined) {
                this.newPaymentOption = this.$route.query.data;
            }
        },
    })
</script>
